import { Mark, mergeAttributes } from "@tiptap/core";

export interface UnderlineOptions {
  HTMLAttributes: Record<string, any>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    underline: {
      /**
       * Set an underline mark
       */
      setUnderline: (attrs?: { color?: string }) => ReturnType;
      /**
       * Toggle an underline mark
       */
      toggleUnderline: () => ReturnType;
      /**
       * Unset an underline mark
       */
      unsetUnderline: () => ReturnType;
    };
  }
}

export const Underline = Mark.create<UnderlineOptions>({
  name: "underline",

  defaultOptions: {
    HTMLAttributes: {},
  },

  addAttributes: () => ({
    color: { default: undefined },
  }),

  parseHTML() {
    return [
      {
        tag: "u",
      },
      {
        tag: "span",
        consuming: false,
        getAttrs: (span) =>
          (span as any).getAttribute("data-id") === "s1" ? {} : false,
      },
      {
        style: "text-decoration",
        consuming: false,
        getAttrs: (style) =>
          (style as string).includes("underline") ? {} : false,
      },
    ];
  },

  renderHTML({ HTMLAttributes, mark }) {
    return [
      "u",
      mergeAttributes(
        this.options.HTMLAttributes,
        { style: `color: ${mark.attrs.color}` },
        HTMLAttributes
      ),
      0,
    ];
  },

  addCommands() {
    return {
      setUnderline:
        ({ color }) =>
        ({ commands }) => {
          return commands.setMark("underline", { color });
        },
      toggleUnderline:
        () =>
        ({ commands }) => {
          return commands.toggleMark("underline");
        },
      unsetUnderline:
        () =>
        ({ commands }) => {
          return commands.unsetMark("underline");
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
    };
  },
});
